import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import { API_URL, ENDPOINTS } from '../../constants/api';

const SalesInvoice = () => {
  const [data, setData] = useState([]);
  const [company, setCompany] = useState([]);

  const { route, id } = useParams();
  const token = getToken();
  useEffect(() => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/activityReport/${route}`;
    // console.log('url:', url);
    const posInvoice = async () => {
      try {
        const response = await axios.post(
          url,
          { invoice_id: id },
          {
            headers: {
              Authorization: token ? `Bearer ${token}` : '',
            },
          }
        );
        setData(response.data.data);
        console.log('api res: ', response.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    const fetchCompany = async () => {
      try {
        // API call to login
        const response = await axios.get(
          `${API_URL}/api/users/get-company/user-login`
        );

        console.log(response.data.company);
        setCompany(response.data.company[0]);
        const company = response.data.company[0];

        if (company?.name) {
          document.title = company.name;
        }

        // Set Favicon
        if (company?.logo) {
          const favicon = document.querySelector("link[rel='icon']");
          if (favicon) {
            favicon.href = company.logo; // Update favicon dynamically
          }
        }
      } catch (error) {
        // Handle error (e.g., invalid credentials)
        console.log('erro:', error);
        // setError('Company not found');
      }
    };

    fetchCompany();

    posInvoice();
  }, [route]);

  // Extract sections
  const header = data?.find((d) => d.title === 'header')?.fields || {};
  //console.log('header:', header);

  const itemsData = data?.find((d) => d.title === 'items');
  const items = Array.isArray(itemsData?.table)
    ? itemsData.table
    : itemsData?.fields
      ? [itemsData.fields]
      : [];

  const payment = data?.find((d) => d.title === 'payment')?.fields || {};

  const formatKey = (key) => {
    // e.g. invoiceNumber -> Invoice Number
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase());
  };

  useEffect(() => {
    if (data && data.length > 0) {
      const images = document.querySelectorAll('img');
      let loaded = 0;

      images.forEach((img) => {
        if (img.complete) {
          loaded++;
        } else {
          img.onload = () => {
            loaded++;
            if (loaded === images.length) window.print();
          };
        }
      });

      if (loaded === images.length) window.print();
    }
  }, [data]);

  return (
    <>
      <div className="invoice-container small-text">
        {/* Display Image Above Invoice */}
        {company.banner && (
          <div className="row">
            <div className="col-12">
              <center>
                <img
                  src={`${API_URL}/${company.banner}`}
                  alt="Company"
                  className="img-fluid"
                  style={{ maxWidth: '50%' }}
                />
              </center>
            </div>
          </div>
        )}
        <h3 className="text-center" style={{ margin: '2px', padding: 0 }}>
          {header.invoice_title}
        </h3>

        <div className="row">
          {Object.entries(header)
            .filter(([key]) => key !== 'invoice_title')
            .map(([key, value]) => (
              <div key={key} className="col-6">
                <strong>{formatKey(key)}:</strong> {value}
              </div>
            ))}
        </div>

        <table className="table">
          <thead>
            <tr>
              {items.length > 0 &&
                Object.keys(items[0]).map((key) => (
                  <th key={key}>{formatKey(key)}</th>
                ))}
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id}>
                {Object.keys(item).map((key) => (
                  <td key={key}>
                    {key === 'price' ? `$${item[key].toFixed(2)}` : item[key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        <div className="d-flex flex-column align-items-end mt-3">
          {Object.entries(payment).map(([key, value], i) => (
            <p key={i}>
              <strong>{key}:</strong> {value}
            </p>
          ))}
        </div>
      </div>
    </>
    // <div>
    //   {/* Display Image Above Invoice */}
    //   {company.banner && (
    //     <div className="row">
    //       <div className="col-12">
    //         <center>
    //           <img
    //             src={`${API_URL}/${company.banner}`}
    //             alt="Company"
    //             className="img-fluid"
    //             style={{ maxWidth: '100%' }}
    //           />
    //         </center>
    //       </div>
    //     </div>
    //   )}
    //   <h2 className="text-center" style={{ margin: '0', padding: 0 }}>
    //     {header.invoice_title}
    //   </h2>

    //   <div className="row">
    //     {Object.entries(header)
    //       .filter(([key]) => key !== 'invoice_title')
    //       .map(([key, value]) => (
    //         <div key={key} className="col-6">
    //           <strong>{formatKey(key)}:</strong> {value}
    //         </div>
    //       ))}
    //   </div>

    //   <table className="table">
    //     <thead>
    //       <tr>
    //         {items.length > 0 &&
    //           Object.keys(items[0]).map((key) => (
    //             <th key={key}>{formatKey(key)}</th>
    //           ))}
    //       </tr>
    //     </thead>
    //     <tbody>
    //       {items.map((item) => (
    //         <tr key={item.id}>
    //           {Object.keys(item).map((key) => (
    //             <td key={key}>
    //               {key === 'price' ? `$${item[key].toFixed(2)}` : item[key]}
    //             </td>
    //           ))}
    //         </tr>
    //       ))}
    //     </tbody>
    //   </table>

    //   {/* Payment summary aligned right */}
    //   <div className="d-flex flex-column align-items-end mt-3">
    //     {Object.entries(payment).map(([key, value], i) => (
    //       <p key={i}>
    //         <strong>{key}:</strong> {value}
    //       </p>
    //     ))}
    //   </div>
    // </div>
  );
};

export default SalesInvoice;
